import React,{useState} from 'react';
import Modal from 'jd-library/Modal';
import Button from '../../common/Button/Button';
import JdRepresentativeProfile from './jdRepresentativeProfile';
import styles from './AuditDocModal.scss';
import {useHistory} from "react-router-dom";
import {identifyAuditFlow,fetchAuditUrl} from "../../utills";
import axios from 'axios';

const AuditDocModal = props => {
    let history = useHistory();
    let displayDocId = '';
    if(props.session && props.session.docId){
        displayDocId = props.session.docId;
    }
    const [skipContractState, updateContractState] = useState('');
    const [BtnLoader, updateBtnLoader] = useState(false);
    const [secondBtnLoader, updateSecBtnLoader] = useState(false);

    const skipContract = () =>{
        if(BtnLoader) {
            return;
        }
        updateBtnLoader(true);
        axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=skipDocIdForAudit&docId=${props.session.docId}`).then((data) => {
            if(data.data && data.data.status){
                updateContractState('contractSkipped');
            }
            updateBtnLoader(false);
       })
    }
    let typeOfContract = "Furlough";
    if(props.auditDocModal.queueType == 'regular') {
        typeOfContract = 'Regular';
    } else if (props.auditDocModal.queueType == 'contractor') {
        typeOfContract = 'Contractor';
    } else if (props.auditDocModal.queueType == 'contractorv2') {
        typeOfContract = 'Contractor V2';
    }else if(props.auditDocModal.queueType == 'objectionFree'){
        typeOfContract = 'Objection Free';
    }else if(props.auditDocModal.queueType == 'objectionPaid'){
        typeOfContract = 'Objection Paid';
    }else if(props.auditDocModal.queueType == 'brandedMrp'){
        typeOfContract = 'MRP Compliance';
    } else if(props.auditDocModal.queueType == 'paidRegularService') {
        typeOfContract = 'Paid Regular Service';
    } else if(props.auditDocModal.queueType == 'nonpaidRegularService') {
        typeOfContract = 'Non-Paid Regular Service';
    } else if(props.auditDocModal.queueType == 'paidRestrictedService') {
        typeOfContract = 'Paid Restricted Service Category';
    } else if(props.auditDocModal.queueType == 'nonpaidRestrictedService') {
        typeOfContract = 'Non-Paid Restricted Service Category';
    } else if(props.auditDocModal.queueType == 'onboardEmpQueue') {
        typeOfContract = 'Onboarding Employee';
    } else if(props.auditDocModal.queueType == 'paidObjectionalService') {
        typeOfContract = 'Paid Objectionable Service';
    } else if(props.auditDocModal.queueType == 'nonpaidObjectionalService') {
        typeOfContract = 'Non-Paid Objectionable Service';
    } else if(props.auditDocModal.queueType == 'branded') {
        typeOfContract = 'Branded Product';
    } else if(props.auditDocModal.queueType == 'customSellonline') {
        typeOfContract = 'Marketplace';
    }else if (props?.isContractor){
        typeOfContract = 'Corrector';
    }
    return(
        <Modal
        settings= {{
            modalId: 'auditLastModal',
            variant: "action",
            class: styles['auditlast-modal']
        }}
        backdropStatic={props.auditDocModal.from != 'skipContract' || skipContractState != ''}
        onHidden={() => props.updateAuditLastModal(false)}
        >
        {props.auditDocModal.from == 'skipContract' && !skipContractState ? <Modal.CloseIcon />: null}
        {skipContractState ?
                (<><Modal.Header className={styles['modal-header']}>
                    Contract Skipped For Audit
                </Modal.Header>
                <div className = {styles['audit-body']}>
                <Button
                    size="lg"
                    block
                    className = {styles['skip-btn']}
                    showLoader = {BtnLoader}
                    clickHandler={() => {
                        if(BtnLoader) {
                            return;
                        }
                        updateBtnLoader(true);
                        fetchAuditUrl({
                            cb: (data) => {
                                props.fetchResolve({data});
                                updateBtnLoader(false);
                            }
                        });
                    }}
                >
                    Audit Another Contract
                </Button>
                <Button
                    size="lg"
                    block
                    variant="default"
                    showLoader={secondBtnLoader}
                    clickHandler={() => {
                        // showSuccessPage(true);
                        if(secondBtnLoader) {
                            return;
                        }
                        updateSecBtnLoader(true);
                        history.push(props.auditHomePath);
                    }}
                >
                    {'Go to Home Page'}
                </Button>
                </div> </>)
        : <div className = {`${styles['audit-body']}`}>
            {props.auditDocModal.queueType && props.auditDocModal.from != 'skipContract' && props.auditDocModal?.noMoreRecords ? (
                <div className = {styles['audit-text']}>
                {`No Products / Services are pending for  ${props.isCorrector ? 'Correction' : 'Audit'} in ${!props.isCorrector ?  typeOfContract : ''} ${props.isCorrector ? 'Correction' : 'Audit'} Queue`}
                </div>
            ):
            (<><div className = {styles['audit-text']}>
                {props.auditDocModal.from != 'skipContract' ? "All products / services of this "+(props.auditDocModal.queueType=='onboardEmpQueue' ? 'agent' : 'DocID')+" have been "+(props.isCorrector ? 'corrected' : 'audited')+"." : 'Are you sure you want to skip this contract for '+(props.isCorrector ? 'correct' : 'audit')+'?'}
            </div>
            {props.auditDocModal.queueType!='onboardEmpQueue' && <div className = {`${styles['audit-text-profile']}`}>
                <JdRepresentativeProfile session = {props.session} showToastMessage = {props.showToastMessage}
                dontShowButtons = {props.dontShowButtons}
                from = {props.auditDocModal.from}
                dontShowViewButton = {true}
                isShowConnectedNumberButton={false}
                />
            </div>
            }
            { props.auditDocModal.from != 'skipContract' && props.auditDocModal.queueType!='onboardEmpQueue' && <div className = {styles['audit-view-all-holder']}>
                <Button 
                    variant="default"
                    className = {styles['audit-view-all']}
                    clickHandler={() => {
                        const search = identifyAuditFlow({checkType: true});
                        if(search.searchAudit) {
                            window.history.go(-2);
                        } else {
                            let url = `/products?docId=${displayDocId}&searchBy=docId&showResultBy=contracts&useAuditApi=true&isAuditUrl=true&isSpecialContract=true&fromFetchFlow=true`;
                            if(search.loadedInIframe) {
                                url += '&loadedInIframe=true';
                            }
                            history.push(url);
                        }
                    }
                }>
                    View All Products/Services
                </Button>
            </div>}
            { props.auditDocModal.from != 'skipContract' && <div className = {styles['audit-text']}>
            Please click on continue to {props.isCorrector ? 'correct' : 'audit'}  products/services of the next {props.auditDocModal.queueType=='onboardEmpQueue' ? 'agent' : 'Doc ID'}
            </div>}</>)}
            <Button
                size="lg"
                block
                className = {styles['audit-continue']}
                showLoader = {BtnLoader}
                clickHandler={() => {
                    if(props.auditDocModal.from == 'skipContract') {
                        skipContract();
                    } else if(props.auditDocModal.cb) {
                        props.auditDocModal.cb();
                    }
                }
            }
            >
                { props.auditDocModal.from == 'skipContract' ? 'Skip Contract' : 'Continue'}
            </Button>
            </div>}
    </Modal>
    )
}
export default AuditDocModal;